<template src="./Overview.html"></template>
<script lang="js">
import Vue from 'vue';

export default Vue.extend({
  name: 'nmouc-overview',
  computed: {
    lastSync() {
      const t = "overview.synchronisationtime";
      if (this.$store.state.mapupdateInformation.lastSyncInformation === undefined) {
        return '';
      } else if (this.$store.state.mapupdateInformation.lastSyncInformation.seconds !== 0) {
        return this.$t(t, {
          time: this.$store.state.mapupdateInformation.lastSyncInformation.seconds + ' ' + this.$t('overview.synchronisationtime.seconds')
        });
      } else if (this.$store.state.mapupdateInformation.lastSyncInformation.minutes !== 0) {
        return this.$t(t, {
          time: this.$store.state.mapupdateInformation.lastSyncInformation.minutes + ' ' + this.$t('overview.synchronisationtime.minutes')
        });
      } else if (this.$store.state.mapupdateInformation.lastSyncInformation.hours !== 0) {
        return this.$t(t, {
          time: this.$store.state.mapupdateInformation.lastSyncInformation.hours + ' ' + this.$t('overview.synchronisationtime.hours')
        });
      } else if (this.$store.state.mapupdateInformation.lastSyncInformation.days !== 0) {
        return this.$t(t, {
          time: this.$store.state.mapupdateInformation.lastSyncInformation.days + ' ' + this.$t('overview.synchronisationtime.days')
        });
      } else {
        return '';
      }
    },
    countOfUpToDateRegions() {
      return this.$store.state.mapupdateInformation.mapRegions.reduce((a, v) => (v.upToDate === true ? a + 1 : a), 0);
    },
    countOfOutdatedRegions() {
      return this.$store.state.mapupdateInformation.mapRegions.reduce((a, v) => (v.upToDate === false ? a + 1 : a), 0);
    },
    showOtaLabel() {
      return this.$store.state.mapupdateInformation.otaSupportEnabled;
    },
    showManualUpdateBtn() {
      return this.$store.state.mapupdateInformation && this.$store.state.mapupdateInformation.mapRegions.some(val => val.upToDate === false);
    },
    showOtaChangeBtn() {
      return this.$store.state.mapupdateInformation && this.$store.state.mapupdateInformation.otaSupportEnabled &&
        this.$store.state.mapupdateInformation.mapRegions.some(r => r.selectedOTARegion) && !(this.$store.state.mapupdateInformation.mapRegions.length === 1)
    },
    showOtaChooseBtn() {
      return this.$store.state.mapupdateInformation && this.$store.state.mapupdateInformation.otaSupportEnabled && !this.$store.state.mapupdateInformation.mapRegions.some(r => r.selectedOTARegion)
    },
    textModelDescription() {
      if (this.$store.state.model === undefined) {
        return '';
      }
      return '<span class=\'model-description-no-wrap\'>' + this.$store.state.model + '</span>';
    }
  },
  methods: {
    setLabelOtaRegionHovered(hovered) {
      this.$store.commit('setLabelOtaRegionHovered', hovered)
    },
    setLabelUpToDateRegionHovered(hovered) {
      this.$store.commit('setLabelUpToDateRegionHovered', hovered)
    },
    setLabelOutdatedRegionHovered(hovered) {
      this.$store.commit('setLabelOutdatedRegionHovered', hovered)
    },
  },
});
</script>
<style lang="scss" src="./Overview.scss"></style>
